import { requestManualRedispatch as postManualRedispatch } from '@/console/api/redispatch'
import { ManualRedispatchRequest, ManualRedispatchResponse, ManualRedispatchResult } from '@/console/api/types'
import { empty, PanelState } from '@/console/state/panelState'

/**
 * LOGISPRD-12506 Task 14 — F-OPT 재발사 실제 API 배선. 1단계 목데이터(`mocks/redispatch.ts` +
 * `scenarioState`)를 걷어내고 `POST /workflow/outbound-dispatch/manual` 실제 호출로 바꾼다.
 * `mocks/redispatch.ts` 는 이 파일에서 더 이상 import 하지 않는다(파일 자체는 Task 19 가 지운다).
 *
 * `useRedispatchResults` 의 시그니처(`(): PanelState<ManualRedispatchResult[]>`)는 1단계와 동일하게
 * 고정돼 있다. 재발사는 "조회"가 아니라 "제출"로만 결과가 생기는 액션형 패널이라(§4.2, Dispatcher
 * Hold 의 `useHoldRules` 류 조회 훅과 다른 축), 제출 전에는 보여줄 실제 데이터가 없다 — 1단계처럼
 * 가짜 성공 목록을 미리 보여주지 않고(Task 7·`slsCompare.ts` 가 세운 원칙과 동일한 결) 항상 고정
 * `empty` 를 낸다. 제출 이후의 실제 상태(대기 id · wakeUp · submitting · 결과)는 이제
 * `src/console/tabs/fopt/useManualRedispatch.ts`(LOGISPRD-13034)가 들고, `FoptTab` 을 통해
 * `OrderSearchPanel` 과 `RedispatchPanel` 이 이 base 위에 함께 덮어 그린다.
 */
const NO_RESULTS_YET_REASON = '재발사 결과가 없어요. 위에서 대상을 입력하고 재발사를 눌러요.'

export const useRedispatchResults = (): PanelState<ManualRedispatchResult[]> => empty(NO_RESULTS_YET_REASON)

/**
 * `RedispatchPanel` 이 재발사 버튼 확인 다이얼로그 승인 후 부르는 제출 함수. 시그니처는 1단계와
 * 동일하게 유지한다 — 화면 쪽 호출부(`requestManualRedispatch({ standardOrderIds, wakeUp })`)를
 * 바꿀 필요가 없다. 내부는 `api/redispatch.ts` 의 실제 호출로 위임할 뿐, 추가 로직(재시도·폴백
 * 등)을 얹지 않는다 — 동기 호출·최대 5분·재시도 금지라는 계약을 그대로 통과시킨다.
 */
export const requestManualRedispatch = (request: ManualRedispatchRequest): Promise<ManualRedispatchResponse> => postManualRedispatch(request)
